<div class="flex flex-col gap-1" data-test-class="filter-group">
	<span class="font-semibold">
		{{ 'compositions.filters.type.' + title() | translate }}
	</span>
	<vp-selection-card
		[hideNativeInput]="true"
		[options]="options()"
		[stacked]="true"
		(optionsChange)="onOptionsChange($event)"
		controlType="checkbox"
	/>
</div>
